import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Image } from 'react-bootstrap'
import { moreIcon } from '../../assets'

export default function Section3() {
  return (
    <div className='section-3 position-relative'>
      <AnimationOnScroll duration={2} animateIn="animate__slideInUp" className='section3-details position-absolute d-flex flex-column justify-content-around'>
        <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
          <h3 style={{ fontWeight: '800', fontSize: '2em', color: '#122E31', textAlign: 'start' }}>India's primier<br /> plywood<br /> manufacturer</h3>
        </AnimationOnScroll>
        <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
          <p align='left' style={{ fontWeight: '500', fontSize: '1.5em', marginTop: '24px' }}>One of the main virtues of Kaptain Ply is its ability to provide outstanding products that can be claimed as a No:1 in the market in terms of quality and aesthetics.</p>
        </AnimationOnScroll>
        <AnimationOnScroll duration={2} animateIn="animate__slideInUp" className='learn-more-button d-flex align-items-center'>
          LEARN MORE
          <Image src={moreIcon} className='mx-3' />
        </AnimationOnScroll>
      </AnimationOnScroll>
    </div>
  )
}
